import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

    ngOnInit() {
        this.categories.forEach(category => {

            // Alphabetize if needed
            if (category.isAlphabetized !== false) {
                category.children = category.children.sort((a, b) => {
                    return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)
                });
            }
        });
    }

    private navHiddenPages: string[] = [
        '/layout-default',
        '/layout-wide',
        '/layout-article',
        '/layout-has-sidebar',
        '/header-footer'
    ];
    public query: string = '';

    constructor(private router: Router) {}

    public readonly categories: DsNavCategory[] = [
        {
            name: 'Components',
            children: [
                {name: 'Headings', link: '/headings'},
                {name: 'Paragraphs', link: '/paragraphs'},
                {name: 'Banners', link: '/banners'},
                {name: 'Buttons', link: '/buttons'},
                {name: 'Button Bars', link: '/button-bars'},
                {name: 'Rows', link: '/rows'},
                {name: 'Forms', link: '/forms'},
                {name: 'Errors', link: '/errors'},
                {name: 'Icons', link: '/icons'},
                {name: 'Injected Content', link: '/injected-content'},
                {name: 'Select Bars', link: '/select-bars'},
                {name: 'Tooltips', link: '/tooltips'},
                {name: 'Links', link: '/links'},
                {name: 'Lists', link: '/lists'},
                {name: 'Navigation', link: '/navigation'},
                {name: 'Numbers', link: '/numbers'},
                {name: 'Themes', link: '/themes'},
                {name: 'Cards', link: '/cards'},
                {name: 'Modals', link: '/modals'},
                {name: 'Dividers', link: '/dividers'},
                {name: 'Colors', link: '/colors'},
                {name: 'Date and Time', link: '/date-time'},
                {name: 'Dialogs', link: '/dialogs'},
                {name: 'Alerts', link: '/alerts'},
                {name: 'Tables', link: '/tables'},
                {name: 'Toggles', link: '/toggles'},
                {name: 'Pagination', link: '/pagination'}
            ]
        },
        {
            name: 'Web Components',
            children: [
                {name: 'Headers & Footers', link: '/header-footer'}
            ]
        },
        {
            name: 'Brand Guidelines',
            children: [
                {name: 'Capitalization', link: '/capitalization'},
                {name: 'Punctuation', link: '/punctuation'},
                {name: 'Proper Nouns', link: '/proper-nouns'},
                {name: 'Space and Alignment', link: '/space'}
            ]
        },

        {
            name: 'Templates',
            children: [
                {name: 'Default Container', link: '/layout-default'},
                {name: 'Wide Container', link: '/layout-wide'},
                {name: 'Article Container', link: '/layout-article'},
                {name: 'Container With Sidebar', link: '/layout-has-sidebar'}
            ]
        },
        {
            name: 'Technical Details',
            children: [
                {name: 'Dos and Do nots', link: '/do-dont'},
                {name: 'Breakpoints', link: '/breakpoints'},
                {name: 'Naming Convention', link: '/naming'}
            ]
        },
        {
            name: 'Utilities',
            children: [
                {name: 'Margins', link: '/margins'},
                {name: 'Padding', link: '/padding'},
                {name: 'Font Weights', link: '/font-weights'},
                {name: 'Text Align', link: '/text-align'},
                {name: 'Background Color', link: '/background-color'},
                {name: 'Borders', link: '/borders'},
                {name: 'Cursors', link: '/cursor'},
                {name: 'Display', link: '/display'},
                {name: 'Flex', link: '/flex'},
                {name: 'Text Color', link: '/text-color'},
                {name: 'Text Misc.', link: '/text-misc'}
            ]
        },
        {
            name: 'Helpers',
            children: [
                {name: 'Get Font Number', link: '/get-font-number'},
                {name: 'Set Weight', link: '/set-weight'}
            ]
        },
        {
            name: 'Development',
            isAlphabetized: false,
            children: [
                {name: 'Implementing', link: '/implementing'},
                {name: 'Developing', link: '/developing'}
            ]
        }
    ];

    public goTo(url: string): void {
        this.router.navigate([url]);
    }

    public isOnPage(url: string): boolean {
        return this.router.isActive(url, true);
    }

    public isNavVisible(): boolean {
        return this.navHiddenPages.includes(this.router.url) === false;
    }

    public doesCategoryMatchQuery(category: DsNavCategory): boolean {
        return category.children.filter(
            child => this.doesPageMatchQuery(child.name)
        ).length > 0;
    }

    public doesPageMatchQuery(page: string): boolean {
        const upperCasePage = page.toUpperCase();
        const queryUpperCase = this.query.toUpperCase();

        return upperCasePage.includes(queryUpperCase);
    }
}

interface DsNavItem {
    name: string;
    link?: string;
    hideNav?: boolean;
}

interface DsNavCategory {
    name: string;
    children?: DsNavItem[];
    link?: string;
    isAlphabetized?: boolean;
}